import React, { useEffect, useState, useRef } from "react";
import NavBar from "../../Components/Navbar/navbar";
import styles from "../Styles/tables.module.css";
import axios from "axios";
import { HiPencil, HiTrash, HiClipboardList, HiSearch, HiX } from "react-icons/hi";
import { TbActivity, TbArrowBigLeftFilled, TbArrowBigRightFilled, TbArrowBigRightLinesFilled, TbArrowBigLeftLinesFilled, TbMinus, TbPassword } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../Components/DeleteModal/deletemodal";
import Alert from "../../Components/Alert/alert";
import RefreshToken from "../../Components/RefreshToken/RefreshToken";
import { Url, getUser } from "../../Constants/globals";
import stylesPassword from "../../Components/DeleteModal/deletemodal.module.css";

async function deleteUserFunction(id, reason){
  if (!reason){
    return  [0, <Alert type={"error"}>Apresente uma razão</Alert>];
  }
  try {
    await axios.delete(`${Url}/users/${id}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
      data: {
        reason: reason,
      },
    });
    return [200, <Alert type={"success"}>Utilizador eliminado com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await deleteUserFunction(id, reason);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar o utilizador"}</Alert>];
    }
  };
}

async function changeActivityUserFunction(id, reason){
  if (!reason){
    return  [0, <Alert type={"error"}>Apresente uma razão</Alert>];
  }
  try {
    await axios
    .post(`${Url}/users/${id}/activity`,
    {
      reason: reason
    },
    {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return [200, <Alert type={"success"}>Utilizador desativado com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await changeActivityUserFunction(id, reason);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao desativar o utilizador"}</Alert>];
    }
  };
}

async function getUsers(page, search){
  try {
    const res = await axios
    .get(`${Url}/users?page=${page ? page : 1}${search ? "&search="+search : ""}`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getUsers(page, search);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function handleChangePassword(new_password){
  try {
    await axios.post(`${Url}/users/change-my-password`, {
      password: new_password
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      }
    });
    return true;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await handleChangePassword(new_password);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return false;
    }
  };
}

function ChangePassword({close, setAlert}) {

  const [isPoppedOut, setIsPoppedOut] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  async function handlePassword() {
    await setAlert("");
    if (newPassword.trim() === "") return setAlert(<Alert type={"error"}>Escolha uma nova palavra-passe</Alert>);
    else if (newPassword.length < 8) return setAlert(<Alert type={"error"}>A palavra-passe deverá conter um mínimo de 8 caracteres</Alert>);
    else if (newPassword !== confirmPassword) return setAlert(<Alert type={"error"}>A palavra-passe e a sua confirmação não coincidem</Alert>)
    const res = await handleChangePassword(newPassword);
    if (res) {
      close("");
      return setAlert(<Alert type="success">Palavra-passe alterada com sucesso</Alert>);
    }
    else {
      return setAlert(<Alert type="error">Ocorreu um erro ao alterar a palavra-passe</Alert>)
    }
  }

  function handleClose() {
    setIsPoppedOut(true);
    setTimeout(() => {
      close("");
    }, 250);
  }

  return (
    <div className={`${stylesPassword.bodyDelete} ${isPoppedOut ? stylesPassword.popout : stylesPassword.popin}`}>
      <div className={stylesPassword.center}>
        <div className={stylesPassword.column}>
          <h4 style={{margin:0}}>Alterar palavra-passe</h4>
          <div>
            <div className={styles.formBlockSection} style={{marginTop: "10px"}}>
              <p>Nova palavra-passe:</p>
              <input type="password" onChange={(e) => setNewPassword(e.target.value)}/>
            </div>
            <div className={styles.formBlockSection} style={{marginTop: "10px"}}>
              <p>Confirmação da nova palavra-passe:</p>
              <input type="password" onKeyDown={(e) => {if (e.key === "Enter") handlePassword()}} onChange={(e) => setConfirmPassword(e.target.value)}/>
            </div>
          </div>
          <div className={stylesPassword.buttons}>
            <button className={stylesPassword.actionButton} onClick={() => handlePassword()}>Alterar</button>
            <button className={stylesPassword.backButton} onClick={() => handleClose()}>Voltar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Utilizadores({userPermissions}) {

  const navigate = useNavigate();
  const searchRef = useRef(null);

  const [loadingData, setLoadingData] = useState(true);
  const [usersData, setUsersData] = useState([]);
  const [currentPage, setCurrentPage] = useState("");
  const [nextPage, setNextPage] = useState("");
  const [previousPage, setPreviousPage] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [deleteUser, setDeleteUser] = useState("");
  const [alert, setAlert] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [isPoppedOut, setIsPoppedOut] = useState(false);
  const [nomeSearch, setNomeSearch] = useState("");
  const [changePassword, setChangePassword] = useState("");
  const [total, setTotal] = useState(0);

  async function assignData() {
    const thisUsersData = await getUsers(currentPage);
    setUsersData(thisUsersData);
    setCurrentPage(thisUsersData.current_page);
    setNextPage(thisUsersData.next_page);
    setPreviousPage(thisUsersData.prev_page);
    setPerPage(thisUsersData.per_page);
    setTotal(thisUsersData.total_users);
    setLoadingData(false);
  }

  async function handlePageChange(next, start) {
    if (next) {
      const newUsersData = await getUsers(start ? start : nextPage, nomeSearch);
      setUsersData(newUsersData);
      setCurrentPage(newUsersData.current_page);
      setNextPage(newUsersData.next_page);
      setPreviousPage(newUsersData.prev_page);
      setPerPage(newUsersData.per_page);
      setTotal(newUsersData.total_users);
    }
    else if (!next && previousPage) {
      const newUsersData = await getUsers(previousPage, nomeSearch);
      setUsersData(newUsersData);
      setCurrentPage(newUsersData.current_page);
      setNextPage(newUsersData.next_page);
      setPreviousPage(newUsersData.prev_page);
      setPerPage(newUsersData.per_page);
      setTotal(newUsersData.total_users);
    }
    else {
      return;
    }
  }

  const handleSearchContainer = () => {
    if (showSearch){
      setIsPoppedOut(true);
      setTimeout(() => {
        setShowSearch(false);
        setIsPoppedOut(false);
      },280);
    } else {
      setShowSearch(true);
      setTimeout(() => {
        searchRef.current.focus();
      }, 280);
    }
  }

  async function handleSearch(input) {
    if (input === false){
      setNomeSearch("");
    }
    const searchUsersData = await getUsers(1, input === false ? "" : nomeSearch);
    setCurrentPage(searchUsersData.current_page);
    setNextPage(searchUsersData.next_page);
    setPreviousPage(searchUsersData.prev_page);
    setPerPage(searchUsersData.per_page);
    setUsersData(searchUsersData);
    setTotal(searchUsersData.total_users);
  }

  async function getAlertDelete(id, reason) {
    if (id){
      await setAlert("");
      const res = await deleteUserFunction(id, reason);
      setAlert(res[1]);
      assignData()
      return res;
    }
  }

  async function getAlertActivity(id, reason) {
    if (id){
      await setAlert("");
      const res = await changeActivityUserFunction(id, reason);
      setAlert(res[1]);
      assignData();
      return res;
    }
  }

  function getLastPage(){
    const calc = total / perPage;
    const calcNoDecimals = Math.trunc(calc);
    if (calc > calcNoDecimals) return calcNoDecimals + 1;
    else return calcNoDecimals;
  }

  useEffect(() => {
    assignData();
  }, []);

  return (
    <div className="body">
      {alert}
      {deleteUser}
      {changePassword}
      <NavBar current={"utilizadores"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ? ""
        :
        <div style={{position: "relative"}}>
          <div className={styles.tableButtons}>
            <button className={`${styles.btnAdd} ${showSearch ? styles.btnSearchActive : ""}`} onClick={() => handleSearchContainer()}>
              <HiSearch size={20}/>
              <p className={styles.textAdd}>Procurar</p>
            </button>
          </div>
          <div className={styles.content}>
          {
            showSearch ?
              <div className={`${styles.container} ${showSearch ? styles.popin : ""} ${isPoppedOut ? styles.popout : ""}`}>
                <input
                  className={styles.searchInput}
                  ref={searchRef}
                  onChange={(e) => setNomeSearch(e.target.value)}
                  placeholder="Procurar por nome"
                  value={nomeSearch}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      handleSearch();
                    }
                  }}
                />
                <div style={{backgroundColor: "var(--inputBackground)", display: "flex", borderTopRightRadius: "4px", borderBottomRightRadius: "4px"}}>
                  <button className={styles.btn} style={{cursor: "default", marginRight: "0"}} onClick={() => handleSearch(false)}><HiX size={16} color="#9c9c9c"/></button>
                  <button className={styles.btn} style={{marginLeft: "0"}} onClick={() => handleSearch()}><HiSearch size={18}/></button>
                </div>
              </div>
            : ""
          }
          <div className={styles.table}>
            <div className={styles.usersColumn}>
              <p></p>
              <p>Nº</p>
              <p>Nome</p>
              <p>Email</p>
              <p>Contacto</p>
              <p>Ações</p>
              <p></p>
            </div>
            <div className={styles.scrollContent}>
              {
                usersData?.users?.length > 0 ?
                usersData?.users?.map((user, index) =>
                  <div key={user.id} className={styles.usersInfo} style={ index % 2 !== 0 ? {backgroundColor: "var(--inputBackground)"} : {}}>
                    <div style={{display: "flex", justifyContent: "center"}}>
                      {
                        user.photo_uri && user.approved ?
                        <img className={styles.foto} alt="img" src={`${Url}/image/${user.photo_uri}`} />
                        :
                        <img className={styles.noFoto} alt="img" />
                      }
                    </div>
                    <p title={user.num}>{user.num ? user.num : "-"}</p>
                    <p title={user.full_name}>{user.full_name ? user.full_name : "-"}</p>
                    <p title={user.email}>{user.email ? user.email : "-"}</p>
                    <p title={user.phone}>{user.phone ? user.phone : "-"}</p>
                    <div className={styles.actions}>
                      <HiPencil className={styles.icon} onClick={() => navigate(`/colaboradores/${user.id}`)} size={22}/>
                      <HiTrash className={styles.icon} onClick={() => setDeleteUser(<DeleteModal close={setDeleteUser} user={true} objectId={user.id} objectName={user.full_name} deleteFunction={getAlertDelete} reason={true} userActivity={user.is_active} changeActivity={getAlertActivity}/>)} size={22}/>
                      <HiClipboardList className={styles.icon} onClick={() => navigate(`/utilizadores/${user.id}/logs`)} title="Logs" size={22} />
                      {
                        user.id === getUser().info.id ? <TbPassword className={styles.icon} onClick={() => setChangePassword(<ChangePassword close={setChangePassword} setAlert={setAlert} />)} title="Alterar password" size={22} />:""
                      }
                    </div>
                    <div className={styles.actions}>
                      {
                        user.is_active ? 
                        <TbActivity size={22} color={"var(--successBackground)"} title={"Ativo"}/>
                        :
                        <TbMinus size={22} color={"var(--errorBackground)"} title={"Inativo"}/>
                      }
                    </div>
                  </div>
                )
                :
                <div className={styles.noData}>
                  <p>Não existem dados</p>
                </div>
              }
            </div>
            {
              previousPage || nextPage ?
              <div className={styles.arrows}>
                <TbArrowBigLeftLinesFilled size={28} color={currentPage && currentPage > 1 ? "" : "#00000000"} onClick={() => handlePageChange(true, 1)}/>
                <TbArrowBigLeftFilled size={28} color={previousPage ? "" : "#00000000"} onClick={() => handlePageChange(false)}/>
                {currentPage ? currentPage : ""}
                <TbArrowBigRightFilled size={28} color={nextPage ? "" : "#00000000"} onClick={() => handlePageChange(true)}/>
                <TbArrowBigRightLinesFilled size={28} color={currentPage !== getLastPage() ? "" : "#00000000"} onClick={() => handlePageChange(true, getLastPage())}/>
              </div>
              : ""
            }
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Utilizadores;